import {Action, ActionReducer, createReducer, on} from '@ngrx/store';
import {DataSourceProvider, DataSourceProvidersState} from './dataSourceProviders';
import {loadDataSourceProviders, loadDataSourceProvidersSuccess} from './dataSourceProviders.actions';
import {TypedAction} from '@ngrx/store/src/models';
import {Serializer, Serializers} from '../../interfaces/serializer';
import {DataSourceProviderComponentObject} from '../../classes/data-source-provider-component-object';

const _reducer: ActionReducer<DataSourceProvidersState> = createReducer(
  { serialized: [], componentObjects: [], loading: false, loaded: false },
  on(loadDataSourceProviders, (state: DataSourceProvidersState, action: TypedAction<string>): DataSourceProvidersState => {
    return {
      ...state,
      loading: true,
      loaded: false
    };
  }),
  on(loadDataSourceProvidersSuccess, (state: DataSourceProvidersState, action: TypedAction<string> & { dataSources: Serializers<DataSourceProvider> }): DataSourceProvidersState => {
    return {
      ...state,
      serialized: action.dataSources,
      componentObjects: action.dataSources.map((dataSource: Serializer<DataSourceProvider>): DataSourceProviderComponentObject => new DataSourceProviderComponentObject(dataSource)),
      loading: false,
      loaded: true
    };
  })
);

export const dataSourceProvidersReducer: ActionReducer<DataSourceProvidersState> = (state: DataSourceProvidersState, action: Action) => _reducer(state, action);
